import { useTranslation } from 'react-i18next';
import { InfiosContainer, InfiosTextBlock } from '@infios/uikit/react';
import type { ClarificationNeededData } from '../../interfaces/chat';
import styles from './ContentBlocks.module.css';

interface ClarificationNeededBlockProps {
  data: ClarificationNeededData;
}

export function ClarificationNeededBlock({ data }: ClarificationNeededBlockProps) {
  const { t } = useTranslation();
  if (!data.missingField) return null;

  return (
    <InfiosContainer type="card">
      <InfiosTextBlock slot="header" weight="bold">
        {t('ChatbotUI.OrderBlocks.ClarificationHeading')}
      </InfiosTextBlock>
      <div className={styles.row}>
        <span className={styles.rowLabel}>{t('ChatbotUI.OrderBlocks.ClarificationMissingField')}</span>
        <span>{data.missingField}</span>
      </div>
    </InfiosContainer>
  );
}
